import React, { useState } from "react";
import { downloadFatigueRulesListPdf } from "./fatigueRulesListPdf";
import "./horizonTable.css";

function FatigueReportsPage() {
  const [isPdfHover, setIsPdfHover] = useState(false);
  const shell = {
    background: "#f3f4f6",
    borderRadius: "20px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    padding: "18px 8px",
    marginBottom: "24px",
  };
  const page = {
    width: "100%",
    maxWidth: "1120px",
    margin: "0 auto 18px auto",
    background: "#ffffff",
    padding: "22px 20px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
    borderRadius: "2px",
  };
  const title = {
    fontSize: "34px",
    fontWeight: "700",
    color: "#8a1831",
    textAlign: "center",
    margin: "2px 0 8px 0",
    letterSpacing: "-0.4px",
  };
  const titleLine = { border: "none", borderTop: "2px solid #8a1831", margin: "0 0 12px 0" };
  const sectionTitle = { fontSize: "22px", fontWeight: "700", color: "#8a1831", margin: "12px 0 8px 0", letterSpacing: "0px" };
  const ruleTitle = { fontSize: "16.5px", fontWeight: "700", color: "#1c1c1c", margin: "8px 0 3px 0" };
  const p = { margin: "0 0 6px 0", color: "#222", fontSize: "14.2px", lineHeight: 1.55 };
  const small = { margin: "0 0 6px 0", color: "#444", fontSize: "13.2px", lineHeight: 1.5 };
  const ul = { margin: "0 0 8px 12px", color: "#222", fontSize: "14.2px", lineHeight: 1.55, paddingLeft: "16px" };
  const tableWrap = { marginTop: "8px", overflowX: "auto" };
  const table = { width: "100%", borderCollapse: "collapse", fontSize: "14.2px", color: "#222" };
  const th = { background: "#8a1831", color: "#fff", textAlign: "left", padding: "9px 12px", border: "1px solid #cfcfcf", fontWeight: "700" };
  const td = { padding: "9px 12px", border: "1px solid #d8d8d8", verticalAlign: "top" };
  const center = { ...td, textAlign: "center" };

  return (
    <div style={shell}>
      <div style={page}>
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "8px" }}>
        <button
          type="button"
            title="Download Fatigue Rules List PDF"
            onClick={() => downloadFatigueRulesListPdf()}
          onMouseEnter={() => setIsPdfHover(true)}
          onMouseLeave={() => setIsPdfHover(false)}
          style={{
            display: "inline-flex",
            alignItems: "center",
              gap: "6px",
              padding: "6px 12px",
              fontSize: "14px",
            fontWeight: "700",
            letterSpacing: "0.2px",
            color: "#ffffff",
            background: isPdfHover
              ? "linear-gradient(135deg, #7f1532 0%, #661029 100%)"
              : "linear-gradient(135deg, #9f1f42 0%, #7f1532 100%)",
            border: isPdfHover ? "1px solid #661029" : "1px solid #7f1532",
            borderRadius: "999px",
            cursor: "pointer",
            boxShadow: isPdfHover
                ? "0 8px 18px rgba(127, 21, 50, 0.3)"
                : "0 4px 12px rgba(127, 21, 50, 0.22)",
              transform: isPdfHover ? "translateY(-1px)" : "translateY(0)",
              transition: "all 0.2s ease",
          }}
        >
          <span
            style={{
                width: "18px",
                height: "18px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "999px",
              background: isPdfHover ? "rgba(255, 255, 255, 0.24)" : "rgba(255, 255, 255, 0.18)",
            }}
          >
              <i className="fa fa-file-pdf-o" style={{ fontSize: "14px", color: "#ffffff" }} />
          </span>
            Fatigue Rules List PDF
        </button>
        </div>
        <h2 style={title}>Fatigue Risk Management - Rules List</h2>
        <hr style={titleLine} />
        <h3 style={sectionTitle}>A. Basic Working Rules</h3>
        <h4 style={ruleTitle}>Rule 1: An employee must have at least 12 hours rest between shifts.</h4>
        <p style={p}>This is measured from the time the employee left the last place of work (outbound shift) to the time they started at the first place of work (oncoming shift).</p>
        <h4 style={ruleTitle}>Rule 2: A single shift must not be longer than 12 hours.</h4>
        <p style={p}>The shift duration is the time from on-duty (arrival at first place of work) to off-duty (departure from last place of work). Break time is not deducted from the shift duration for the purpose of this rule.</p>
        <h4 style={ruleTitle}>Rule 3: An employee must not work more than 72 hours in any rolling 7 days.</h4>
        <p style={p}>Rolling 7 days means any consecutive 7-day window ending on the current day. The total is the sum of all shift durations within that window. Rest days contribute 0 hours but do not reset the rolling total.</p>
        <h4 style={ruleTitle}>Rule 4: An employee must not work more than 13 shifts in any rolling 14 days.</h4>
        <p style={p}>Rolling 14 days means any consecutive 14-day window ending on the current day. Each day with a recorded shift counts as 1. Rest days are not counted. 13 shifts in 14 days is allowed. The 14th shift in a 14-day window triggers a breach.</p>
        <h4 style={ruleTitle}>Rule 5: Total door-to-door time must not exceed 14 hours.</h4>
        <p style={p}>Door-to-door time = travel time from place of rest to first place of work + shift duration + travel time from last place of work to place of rest. In the app this is calculated as: shift duration + (one-way commute time x 2).</p>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>Rule</th>
                <th style={th}>Condition</th>
                <th style={{ ...th, textAlign: "center" }}>Limit</th>
              </tr>
            </thead>
            <tbody>
              <tr><td style={center}>1</td><td style={td}>Rest between shifts</td><td style={{ ...center, fontWeight: "700" }}>Minimum 12 hours</td></tr>
              <tr><td style={center}>2</td><td style={td}>Single shift duration</td><td style={{ ...center, fontWeight: "700" }}>Maximum 12 hours</td></tr>
              <tr><td style={center}>3</td><td style={td}>Hours in rolling 7 days</td><td style={{ ...center, fontWeight: "700" }}>Maximum 72 hours</td></tr>
              <tr><td style={center}>4</td><td style={td}>Shifts in rolling 14 days</td><td style={{ ...center, fontWeight: "700" }}>Maximum 13 shifts</td></tr>
              <tr><td style={center}>5</td><td style={td}>Door-to-door time</td><td style={{ ...center, fontWeight: "700" }}>Maximum 14 hours</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div style={page}>
        <h3 style={sectionTitle}>B. Fatigue Score Rules (FRI)</h3>
        <h4 style={ruleTitle}>Rule 6: If day shift fatigue score is 35 or more, it is a fatigue issue.</h4>
        <p style={p}>The Fatigue Index (FI) is calculated using the HSE fatigue model. This threshold applies only to day shifts. A day shift is one that starts between 06:00 and 17:59 and does not cross midnight.</p>
        <h4 style={ruleTitle}>Rule 7: If night shift fatigue score is 45 or more, it is a fatigue issue.</h4>
        <p style={p}>A higher threshold is used for night shifts because the fatigue model already produces higher scores during night hours due to the circadian component. A night shift is one that starts at or after 18:00, or before 06:00, or crosses midnight.</p>
        <h4 style={ruleTitle}>Rule 8: If fatigue risk score is 1.6 or more, it is a fatigue issue. This applies to any shift.</h4>
        <p style={p}>The Risk Index (RI) is a multiplier calculated by the HSE fatigue model. A value of 1.0 represents baseline risk. Values above 1.0 indicate elevated risk. This rule applies to both day and night shifts.</p>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr><th style={th}>Rule</th><th style={th}>Condition</th><th style={{ ...th, textAlign: "center" }}>Threshold</th></tr>
            </thead>
            <tbody>
              <tr><td style={center}>6</td><td style={td}>Day shift Fatigue Index (FI)</td><td style={{ ...center, fontWeight: "700" }}>FI &ge; 35</td></tr>
              <tr><td style={center}>7</td><td style={td}>Night shift Fatigue Index (FI)</td><td style={{ ...center, fontWeight: "700" }}>FI &ge; 45</td></tr>
              <tr><td style={center}>8</td><td style={td}>Risk Index (RI) - any shift</td><td style={{ ...center, fontWeight: "700" }}>RI &ge; 1.6</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div style={page}>
        <h3 style={sectionTitle}>C. Exceedance Levels</h3>
        <h4 style={ruleTitle}>Rule 9: General exceedance happens when fatigue scores are high (Rules 6, 7, 8) plus any of the following:</h4>
        <ul style={ul}>
          <li>Working more than 12 hours in one shift</li>
          <li>Exceeding more than 14 hours door-to-door</li>
          <li>Less than 12 hours break between booking off from one shift and starting the next</li>
          <li>Working more than 13 consecutive turns of duty in 14 rolling days</li>
        </ul>
        <h4 style={ruleTitle}>Rule 10: A fatigue assessment must be done.</h4>
        <p style={p}>Form: SF-008-A General Exceedance of Working Hours Assessment.</p>
        <h4 style={ruleTitle}>Rule 11: Level 1 exceedance happens when more than 60 hours are worked in 7 rolling days.</h4>
        <p style={p}>This applies when hours are 60 or more but less than 72 hours.</p>
        <h4 style={ruleTitle}>Rule 12: Extra controls are required for Level 1.</h4>
        <p style={p}>No driving duties. Must not work alone. Additional supervision required. Form: SF-008-B Level 1 Exceedance Fatigue Risk Assessment.</p>
        <h4 style={ruleTitle}>Rule 13: Level 2 exceedance (serious) happens when any of the following occur:</h4>
        <ul style={ul}>
          <li>More than 72 hours in 7 rolling days</li>
          <li>Less than 12 hours rest between shifts</li>
          <li>Shift longer than 12 hours</li>
          <li>Door-to-door time is 14 hours or more</li>
          <li>More than 13 shifts in 14 rolling days</li>
        </ul>
        <h4 style={ruleTitle}>Rule 14: Strong restrictions apply for Level 2 and 24 hours rest is required.</h4>
        <p style={p}>The employee must be removed from duty. A minimum of 24 hours rest is required before the next shift. Form: SF-008-C Level 2 Exceedance of Working Hours Assessment.</p>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr><th style={th}>Level</th><th style={th}>Trigger</th><th style={{ ...th, textAlign: "center" }}>Form</th></tr>
            </thead>
            <tbody>
              <tr><td style={{ ...td, background: "#ecf5eb", fontWeight: "700" }}>General</td><td style={td}>Any of Rules 1, 2, 4, 5 breached, or FI/RI thresholds exceeded (Rules 6, 7, 8)</td><td style={{ ...center, fontWeight: "700" }}>SF-008-A</td></tr>
              <tr><td style={{ ...td, background: "#fff6de", fontWeight: "700" }}>Level 1</td><td style={td}>60 to 72 hours worked in rolling 7 days (Rule 3)</td><td style={{ ...center, fontWeight: "700" }}>SF-008-B</td></tr>
              <tr><td style={{ ...td, background: "#ffefef", fontWeight: "700" }}>Level 2</td><td style={td}>More than 72h in 7 days, or rest &lt; 12h, or shift &gt; 12h, or door-to-door &ge; 14h, or &gt; 13 shifts in 14 days</td><td style={{ ...center, fontWeight: "700" }}>SF-008-C</td></tr>
            </tbody>
          </table>
        </div>
        <p style={{ ...small, marginTop: "8px" }}>If a Level 1 or Level 2 is triggered along with General triggers, the Level 1 or Level 2 takes priority over the General.</p>
        <h3 style={sectionTitle}>D. Forms and Actions</h3>
        <h4 style={ruleTitle}>Rule 15: Every exceedance creates a form automatically.</h4>
        <h4 style={ruleTitle}>Rule 16: The employee must complete the form.</h4>
        <h4 style={ruleTitle}>Rule 17: A manager must review and approve the actions.</h4>
      </div>

      <div style={page}>
        <p style={{ ...p, marginBottom: "10px" }}>The manager may require more risk mitigation which the Line Manager puts into place.</p>
        <h4 style={ruleTitle}>Rule 18: Serious cases require a fatigue management plan.</h4>
        <p style={p}>Any fatigue risk assessment form can identify that a SF-008-D Fatigue Management Plan is required. The plan is not mandatory for every exceedance. It is created by the manager when the fatigue trigger cannot be removed by changing shift times or travel arrangements.</p>
        <p style={p}>Nobody can override fatigue rules. All triggers must either be worked through to eliminate (change shift times, travel times, etc. which sees the fatigue trigger removed). If the trigger cannot be removed then the appropriate risk assessment documentation needs to be completed.</p>
        <h3 style={sectionTitle}>E. Driving Rules</h3>
        <h4 style={ruleTitle}>Rule 19: Driving should normally be no more than 1 hour each way.</h4>
      </div>

      <div style={page}>
        <h3 style={sectionTitle}>Exceedance Mapping - Which Rule Triggers Which Level</h3>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>Condition</th>
                <th style={th}>Rule</th>
                <th style={th}>General</th>
                <th style={th}>Level 1</th>
                <th style={th}>Level 2</th>
              </tr>
            </thead>
            <tbody>
              <tr><td style={td}>Rest &lt; 12 hours between shifts</td><td style={center}>1</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>Yes</td></tr>
              <tr><td style={td}>Shift longer than 12 hours</td><td style={center}>2</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>Yes</td></tr>
              <tr><td style={td}>60 to 72 hours in rolling 7 days</td><td style={center}>3</td><td style={center}>-</td><td style={center}>Yes</td><td style={center}>-</td></tr>
              <tr><td style={td}>More than 72 hours in rolling 7 days</td><td style={center}>3</td><td style={center}>-</td><td style={center}>-</td><td style={center}>Yes</td></tr>
              <tr><td style={td}>More than 13 shifts in rolling 14 days</td><td style={center}>4</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>Yes</td></tr>
              <tr><td style={td}>Door-to-door time 14 hours or more</td><td style={center}>5</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>Yes</td></tr>
              <tr><td style={td}>Day shift FI score &ge; 35</td><td style={center}>6</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>-</td></tr>
              <tr><td style={td}>Night shift FI score &ge; 45</td><td style={center}>7</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>-</td></tr>
              <tr><td style={td}>Risk Index &ge; 1.6 (any shift)</td><td style={center}>8</td><td style={center}>Yes</td><td style={center}>-</td><td style={center}>-</td></tr>
            </tbody>
          </table>
        </div>

        <h3 style={{ ...sectionTitle, marginTop: "18px" }}>Forms Reference</h3>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr><th style={th}>Form</th><th style={th}>Name</th><th style={th}>Trigger</th><th style={th}>Filled by</th></tr>
            </thead>
            <tbody>
              <tr><td style={{ ...td, fontWeight: "700" }}>SF-008-A</td><td style={td}>General Exceedance of Working Hours Assessment</td><td style={td}>Any General exceedance</td><td style={td}>Employee completes, Manager reviews and approves</td></tr>
              <tr><td style={{ ...td, fontWeight: "700" }}>SF-008-B</td><td style={td}>Level 1 Exceedance Fatigue Risk Assessment</td><td style={td}>60 to 72 hours in rolling 7 days</td><td style={td}>Employee completes, Manager reviews and approves</td></tr>
              <tr><td style={{ ...td, fontWeight: "700" }}>SF-008-C</td><td style={td}>Level 2 Exceedance of Working Hours Assessment</td><td style={td}>Any Level 2 trigger</td><td style={td}>Employee completes, Manager reviews and approves</td></tr>
              <tr><td style={{ ...td, fontWeight: "700" }}>SF-008-D</td><td style={td}>Fatigue Management Plan</td><td style={td}>Created by manager when trigger cannot be removed</td><td style={td}>Manager creates, Manager and Employee complete together</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div style={page}>
        <h3 style={sectionTitle}>Complete Rules List</h3>
        <div style={tableWrap}>
          <table style={table}>
          <thead>
              <tr><th style={th}>#</th><th style={th}>Section</th><th style={th}>Rule</th></tr>
          </thead>
          <tbody>
              <tr><td style={center}>1</td><td style={center}>A</td><td style={td}>An employee must have at least 12 hours rest between shifts.</td></tr>
              <tr><td style={center}>2</td><td style={center}>A</td><td style={td}>A single shift must not be longer than 12 hours.</td></tr>
              <tr><td style={center}>3</td><td style={center}>A</td><td style={td}>An employee must not work more than 72 hours in any rolling 7 days.</td></tr>
              <tr><td style={center}>4</td><td style={center}>A</td><td style={td}>An employee must not work more than 13 shifts in 14 rolling days.</td></tr>
              <tr><td style={center}>5</td><td style={center}>A</td><td style={td}>Total door-to-door time must not exceed 14 hours.</td></tr>
              <tr><td style={center}>6</td><td style={center}>B</td><td style={td}>If day shift fatigue score &ge; 35, it is a fatigue issue.</td></tr>
              <tr><td style={center}>7</td><td style={center}>B</td><td style={td}>If night shift fatigue score &ge; 45, it is a fatigue issue.</td></tr>
              <tr><td style={center}>8</td><td style={center}>B</td><td style={td}>If fatigue risk score &ge; 1.6, it is a fatigue issue (any shift).</td></tr>
              <tr><td style={center}>9</td><td style={center}>C</td><td style={td}>General exceedance happens when fatigue scores are high or basic working rules are breached.</td></tr>
              <tr><td style={center}>10</td><td style={center}>C</td><td style={td}>A fatigue assessment (SF-008-A) must be done for any general exceedance.</td></tr>
              <tr><td style={center}>11</td><td style={center}>C</td><td style={td}>Level 1 exceedance happens when 60 or more hours (but less than 72) are worked in rolling 7 days.</td></tr>
              <tr><td style={center}>12</td><td style={center}>C</td><td style={td}>Extra controls are required for Level 1: no driving, no working alone, additional supervision. Form: SF-008-B.</td></tr>
              <tr><td style={center}>13</td><td style={center}>C</td><td style={td}>Level 2 exceedance happens when: &gt;72h in 7 days, or rest &lt;12h, or shift &gt;12h, or door-to-door &ge;14h, or &gt;13 shifts in 14 days.</td></tr>
              <tr><td style={center}>14</td><td style={center}>C</td><td style={td}>Level 2 requires removal from duty and 24 hours mandatory rest before next shift. Form: SF-008-C.</td></tr>
              <tr><td style={center}>15</td><td style={center}>D</td><td style={td}>Every exceedance creates a form automatically.</td></tr>
              <tr><td style={center}>16</td><td style={center}>D</td><td style={td}>The employee must complete the form.</td></tr>
              <tr><td style={center}>17</td><td style={center}>D</td><td style={td}>A manager must review and approve the actions.</td></tr>
              <tr><td style={center}>18</td><td style={center}>D</td><td style={td}>Serious or recurring cases require a fatigue management plan (SF-008-D).</td></tr>
              <tr><td style={center}>19</td><td style={center}>E</td><td style={td}>Driving should normally be no more than 1 hour each way.</td></tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}

export default FatigueReportsPage;
